import { render, staticRenderFns } from "./FormulaDetails.vue?vue&type=template&id=7e61d599"
import script from "./FormulaDetails.vue?vue&type=script&lang=js"
export * from "./FormulaDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports